import { render, staticRenderFns } from "./admin-detail.component.html?vue&type=template&id=6a822800&scoped=true&"
import script from "./admin-detail.component.ts?vue&type=script&lang=ts&"
export * from "./admin-detail.component.ts?vue&type=script&lang=ts&"
import style0 from "./admin-detail.component.scss?vue&type=style&index=0&id=6a822800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a822800",
  null
  
)

export default component.exports